$(function(){
    svg4everybody();
    
    var iOSMatch = navigator.appVersion.match(/iPhone/) || navigator.appVersion.match(/iPad/);
        var versionMatch = navigator.appVersion.match(/iPhone OS ([0-9_]+) /);
        var version = versionMatch && versionMatch.length ? versionMatch.pop().split('_')[0] : false;

        if (iOSMatch === 'iPhone OS' && version !== '10')  {
            document.write('<meta http-equiv="Content-Security-Policy" content="default-src * \'unsafe-inline\' \'unsafe-eval\' data: blob:;">');
        }

    //check if Images Loaded
    $('body').imagesLoaded( function() {
        //Small Timeout
        setTimeout(function(){

            $('body').removeClass('is--loading');

            if(window.breakpoint() != 'breakpoint-mobile') {
                if($('[data-parallax]').length)
                    $('[data-parallax]').jqParallax();

                if($('[data-scroll-button]').length)
                    $('[data-]').jqScrollButton();
            }

            if($('[data-stricky]').length)
                $('[data-stricky]').jqStricky();

            if($('[data-anchor-nav]').length)
                $('[data-anchor-nav]').jqAnchorNav();
            
        }, 1000);
    });
});
